import '../App.css';
import Header from '../components/header';
import Explore from '../components/explore';
import Tools from '../components/Tools';
import HowItWorks from '../components/HowItWorks';
import Choose from '../components/choose';
import Testimonials from '../components/testimonials';
import Workout from '../components/workout';
import Footer from '../components/footer';
import AboutWorkout from '../components/aboutWorkout';
import Core from '../components/core';


function App() {
  return (
   <div>
    <Header/>
    <Explore/>
    <AboutWorkout/>
    <Tools/>
    <Core/>
    <Choose/>
    <Testimonials/>
    <Workout/>
    <Footer/>
   </div>
  );
}

export default App;
